import rewriteURL from "./url";
let originURL;
export default function rewriteCSS(css, origin) {
    originURL = origin;
    return css.replace(/(?<=url\("?'?)[^"'][\S]*[^"'](?="?'?\);?)/g, rewriteCSSURL);
}
function rewriteCSSURL(match) {
    let url = rewriteURL(match, originURL);
    return url;
}
